import { Modal, Card } from 'react-bootstrap'

// import Role from './PollComponents/Role'
// import Event from './PollComponents/Event'
import PollPage from './PollComponents/PollPage'

export default function PollItem({ agenda, item, meeting, swipeHandlers, onPollClosed }) {


  return (
    <Modal.Body
      style={{
        backgroundImage: 'var(--modal-bg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        color: 'var(--foreground)',
        position: 'relative'
      }}
      className='timer-header'
      {...(swipeHandlers || {})}
    >
      <Card
        className="text-center mt-0 mb-0 modal-event-card-shell"
        style={{
          width: '100%',
          maxWidth: '100%',
          minHeight: '100%',
          height: '100%',
          margin: 0,
          border: '1px solid rgba(128, 128, 128, 0.35)',
          borderRadius: '12px',
          background: 'rgba(128, 128, 128, 0.08)',
          backdropFilter: 'blur(4px)',
          boxShadow: 'none'
        }}
      >
        <Card.Body style={{ padding: 0, height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>
          <div className="next-meeting-content" style={{ height: '100%' }}>
            {/* <Role item={item} /> */}
            {/* <Event item={item} /> */}
            <PollPage agenda={agenda} item={item} meeting={meeting} onPollClosed={onPollClosed} />
          </div>
        </Card.Body>
      </Card>
    </Modal.Body >
  )
}